import { Button } from '@chakra-ui/button';
import { useDisclosure } from '@chakra-ui/hooks';

import EditDropPointAddressModal from '../modals/EditDropPointAddress';

export const UpdateDropPointAddress = ({ dropPointId, address, refetch }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (!dropPointId) return null;

  return (
    <>
      <Button variant="outline" colorScheme="brand" size="xs" onClick={onOpen}>
        DropPoint-Adresse ändern
      </Button>

      <EditDropPointAddressModal isOpen={isOpen} onClose={onClose} refetch={refetch} dropPointId={dropPointId} address={address} />
    </>
  );
};
